import React from 'react';
import { RuntimeCoreSplash } from './RuntimeCoreSplash';

export type AppBootScreenProps = {
  showLogo?: boolean;
  logoSrc?: string;
  title?: string;
  subtitle?: string;
  minimal?: boolean;
  'data-testid'?: string;
};

/**
 * Console boot screen (UI-PARITY-SPEC section 10.5). Always the product
 * RuntimeCoreSplash with CordexaCoreLoader variant="hero" - never the orb spinner
 * and never the fallback blue.
 */
export function AppBootScreen({
  title = 'Loading Cortex…',
  'data-testid': dataTestId = 'app-boot-screen',
}: AppBootScreenProps) {
  return (
    <RuntimeCoreSplash
      statusMessage={title}
      data-testid={dataTestId}
    />
  );
}
